/**
 * Prefetch Nav Item Urls
 * @description A simple nav prefetch to improve UX speed for primary pages
 */
const preFetch = () => {
    var head = document.getElementsByTagName('head')[0];
    var anchors = document.querySelectorAll('nav a');
    var i;

    for (i in anchors) {
        if (anchors[i].href && !anchors[i].hash) {
            var link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = anchors[i].href;

            head.appendChild(link);
        }
    }
};

/**
 * Convert Nodelists into arrays
 * @description //Polyfill to turn nodelists into arrays for IE
 */
const convertNodes = () => {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg = window) {
            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
};


/**
 * Replace the current language string with a new one
 * @param {string} originalUrl
 * @param {string} lang
 * @param {string} newLang
 * @return {string}
 */
const replaceLanguageInPathname = (pathname, newLang) => {
    const parts = pathname.slice(1).split('/');
    if (parts.length > 1 && isValidLocaleFormat(parts[0])) {
        if (newLang === 'en') {
            parts.shift();
        } else {
            parts[0] = newLang;
        }
    } else {
        parts.unshift(newLang);
    }

    return `/${parts.join('/')}`;
};


/**
 * @description Returns whether the urlLang is a valid locale format
 * @param {String} urlLang - language from URL
 * @returns {Boolean} True if contextUrlPrefix is a valid config combination
 */
const isValidLocaleFormat = (urlLang = '') => {
    return /^[a-zA-Z]{2}(-[a-zA-Z0-9]{2,3})?$/.test(urlLang);
};


module.exports = {
    isValidLocaleFormat,
    preFetch,
    convertNodes,
    replaceLanguageInPathname
};
